import React, { useContext, useEffect } from "react";
import FilterPopup from "../FilterPopup";
import SelectableList from "../components/SelectableList";
import { getLabel, getSortedPaymentMethodLabels, initialPaymentMethodFilter } from "./FilterTypes/PaymentMethodFilterType";
import { Button } from "semantic-ui-react";
import { FilterContext } from "../FilterContext";
import { areArrayValuesEqual } from "../FilterGroups/instructionUtils";

const PaymentMethodFilter = () => {
  const title = RESX.Payment.PaymentMethod;

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  register("paymentMethod", {
    getTitle: () => title,
    renderSelection: (filter) => <>{getSortedPaymentMethodLabels(filter).join(", ")}</>,
    hasValue: (filter) => filter.selectedPaymentMethods.length > 0,
    reset: () => initialPaymentMethodFilter,
    areEqual: (a, b) => areArrayValuesEqual(a.selectedPaymentMethods, b.selectedPaymentMethods)
  });
  useEffect(() => {
    setInitialValue("paymentMethod", initialPaymentMethodFilter);
  }, []);

  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);
  const [selectedPaymentMethods, setSelectedPaymentMethods] = React.useState(initialPaymentMethodFilter.selectedPaymentMethods);

  const onPopupClose = () => {
    onApply();
  };

  const onPopupOpen = () => {
    setSelectedPaymentMethods(getValue("paymentMethod").selectedPaymentMethods);
    setPopupOpen(true);
  };

  const onPaymentMethodToggled = (paymentMethod: server.dto.PaymentMethods) => {
    const isSelected = selectedPaymentMethods.some(p => p === paymentMethod);
    const newSelection = isSelected
      ? selectedPaymentMethods.filter(p => p !== paymentMethod)
      : [...selectedPaymentMethods, paymentMethod];
    setSelectedPaymentMethods(newSelection);
  };

  const onApply = (e?) => {
    e?.preventDefault();
    setValue("paymentMethod", {
      selectedPaymentMethods
    });
    setPopupOpen(false);
  };

  return <div>
    <FilterPopup
      filterButtonLabel={title}
      width={272}
      content={<form onSubmit={onApply}>
        <div className="margin-bottom">
          <SelectableList
            noSearch
            noScrolling
            items={serverReference.paymentMethods.map(pm => pm.value)}
            selectedItems={selectedPaymentMethods}
            onItemToggled={onPaymentMethodToggled}
            getId={opt => opt}
            getName={opt => getLabel(opt)}
          />
        </div>

        <Button fluid type="submit" primary >
          {RESX.SelectionManager.Apply}
        </Button>
      </form>}

      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
    />
  </div>;
};

export default PaymentMethodFilter;